import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="confirm-dialog"
export default class extends Controller {
  static targets = ["dialog"]

  open() {
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }
}
